export default "__VITE_ASSET__ac3daac8__"